export function init () {
  return new Promise(async (resolve) => {
    window.document.documentElement.setAttribute("data-theme", "didi");
    import("./common/stylus/didi-theme.styl");
    resolve()
  })
}
